export default "__VITE_ASSET__736fb7ed__"